import { ChangeDetectorRef, Component, Inject, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ActionService } from 'src/app/services/action/action.service';
import { ApiService } from 'src/app/services/api/api.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { Location } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';

@Component({
    selector: 'app-site-header',
    templateUrl: './site-header.component.html',
    styleUrls: ['./site-header.component.scss']
})
export class SiteHeaderComponent implements OnInit, OnDestroy {

    @ViewChild('menuTrigger') menuTrigger: MatMenuTrigger;

    subscription: Subscription;
    hideSpecial: boolean = false;
    loggedIn: boolean = false;
    showSearch: boolean = false;
    cart_counter: number = 0;
    user: any = {};
    myCart: any = [];
    studyMethods: any = [];
    partnerInstitutions: any = [];
    nationalQualifications: any = [];
    megaMenuLoaded: boolean = false;
    catalystCourses: any = [];
    megaMenu: any = [];
    selectedMegaMenuCourse: any = {};
    selectedMegaMenuLevel: any = {};
    selectedMegaMenuSubject: any = {};
    upcomingCourse: any = {};
    upcomingSubject: any = {};
    localSubjects: any = [];
    notification: any = '';
    headers: any = [];
    topHeaders: any = [];
    showMenuDropDown: any = '';
    loadingHeader: boolean = true;
    firstName: string = '';
    isBrowser: boolean = false;
    semesters: any = [];
    regions: any = [];
    upcomingCourseState: string = '';

    constructor(
        public router: Router,
        private authenticationService: AuthenticationService,
        private actionService: ActionService,
        private api: ApiService,
        private cd: ChangeDetectorRef,
        private _location: Location,
        private zone: NgZone,
        public snackBar: MatSnackBar,
        private route: ActivatedRoute,
        private gtmService: GoogleTagManagerService,
        @Inject(PLATFORM_ID) platformId: Object,
    ) {

        this.isBrowser = isPlatformBrowser(platformId);

        this.fetch_headers();

        router.events.subscribe((val) => {
            this.showSearch = false;
            this.showMenuDropDown = '';
        });

        this.getNotification();
        this.fetchCourses();
        this.get_study_methods();
        this.fetchStudent();

        let initial_cart = localStorage.getItem('cart');

        if (initial_cart) {
            try {
                initial_cart = JSON.parse(initial_cart);
                this.myCart = initial_cart;
                this.cart_counter = initial_cart.length;
            } catch (err) {

            }
        }

        localStorage.removeItem('headers');

        // Subscribe to the actionService which facilitates the dialog interactions

        this.subscription = this.actionService.getAction().subscribe(data => {
            if (data.action == 'clear_cart') {
                const cart = localStorage.removeItem('cart');
                this.cart_counter = 0;
                this.myCart = [];
            } else if (data.action == 'clear-megamenus') {
                // Failsafe. When clicking anywhere on the html page then dismiss the mega menus

                this.removeClass('courses-show');
                this.removeClass('study-methods-show');
            } else if (data.action == 'gtm') {
                // Push GTM data layer for every visited page

                if (environment.GTM_ID !== '' && this.isBrowser) {
                    const gtmTag = {
                        event: 'page',
                        pageName: data.data.url,
                        pageTitle: data.data.title,
                        page_title: data.data.title,
                    };

                    this.gtmService.pushTag(gtmTag);
                }
            } else {
                let cart = localStorage.getItem('cart');

                if (cart) {
                    cart = JSON.parse(cart);
                    this.myCart = cart;
                    this.cart_counter = cart.length;
                }
            }
        });

        this.authenticationService.userValue.subscribe(x => {
            if (x) {
                this.loggedIn = true;
                this.fetchStudent();
            } else {
                this.loggedIn = false;
            }
        });

    }

    async fetchStudent() {

        const snackMsg: any = localStorage.getItem('snackMsg');
        if (snackMsg) {
            this.snackBar.open(snackMsg, '', {
                verticalPosition: 'top',
                horizontalPosition: 'center',
                duration: 4000,
                panelClass: ['green-snackbar'],

            });
            localStorage.setItem('snackMsg', '');
        }

        let StudentKey = '';

        try {
            const user: any = JSON.parse(localStorage.getItem('user'));
            if (user && user.Result && user.Result.StudentKey && user.Result.StudentKey._text) {
                StudentKey = user.Result.StudentKey._text;
            }
        } catch (err) { }

        const email = localStorage.getItem('user_email');

        localStorage.setItem('first_name', '');

        if (email) {
            await this.api.get_student(email, StudentKey)
                .subscribe(res => {
                    if (res?.Result?.Student) {
                        this.firstName = res.Result.Student.FirstNames._text;

                        localStorage.setItem('first_name', this.firstName);
                    }
                }, (err) => {

                });
        }
    }

    async fetch_headers() {

        await this.api.fetch_headers()
            .subscribe(res => {
                res.data.items.forEach(item => {
                    if (item.header == 'MAIN') {
                        let url = '';
                        let title = '';
                        let subitems = [];

                        if (item.page_id) {
                            url = '/' + item.page.slug;
                            title = item.page.title;
                        } else {
                            url = item.url;
                            title = item.title;
                        }

                        if (item.subitems.length > 0) {
                            item.subitems.forEach(subitem => {
                                let subitem_url = '';
                                let subitem_title = '';

                                if (subitem.page_id) {
                                    if (subitem.page.parent) {
                                        subitem_url = '/' + subitem.page.parent.slug + '/' + subitem.page.slug;
                                    } else {
                                        subitem_url = '/' + subitem.page.slug;
                                    }

                                    subitem_title = subitem.page.title;
                                } else {
                                    url = subitem.url;
                                    title = subitem.title;
                                }

                                subitems.push({
                                    image: subitem.image,
                                    text: subitem.text,
                                    title: subitem_title,
                                    url: subitem_url
                                });
                            });
                        }

                        this.headers.push({
                            title: title,
                            url: url,
                            subitems: subitems
                        });
                    } else if (item.header == 'SUB') {
                        let url = '';
                        let title = '';
                        let subitems = [];

                        if (item.page_id) {
                            url = '/' + item.page.slug;
                            title = item.page.title;
                        } else {
                            url = item.url;
                            title = item.title;
                        }

                        if (item.subitems.length > 0) {
                            item.subitems.forEach(subitem => {
                                let subitem_url = '';
                                let subitem_title = '';

                                if (subitem.page_id) {
                                    if (subitem.page.parent) {
                                        subitem_url = '/' + subitem.page.parent.slug + '/' + subitem.page.slug;
                                    } else {
                                        subitem_url = '/' + subitem.page.slug;
                                    }

                                    subitem_title = subitem.page.title;
                                } else {
                                    url = subitem.url;
                                    title = subitem.title;
                                }

                                subitems.push({
                                    image: subitem.image,
                                    text: subitem.text,
                                    title: subitem_title,
                                    url: subitem_url
                                });
                            });
                        }

                        this.topHeaders.push({
                            title: title,
                            url: url,
                            subitems: subitems
                        });
                    }

                });

                // localStorage.setItem('headers', JSON.stringify(this.headers));
                this.loadingHeader = false;
                this.cd.detectChanges();
            }, (err) => {
                this.loadingHeader = false;
                this.cd.detectChanges();
            });

    }

    clearCart() {

        this.actionService.setAction({
            action: 'clear_cart',
        });

    }

    filterSubject(level, slug) {

        this.actionService.setAction({
            action: 'subject-filter',
            level: level,
            subject: slug
        });

    }

    ngOnInit(): void {
    }

    ngOnDestroy() {

        this.subscription.unsubscribe();

    }

    logout() {


        this.router.navigateByUrl('/home');
        this.authenticationService.logout();

        this.snackBar.open('Logged out successfully', '', {
            verticalPosition: 'top',
            horizontalPosition: 'center',
            duration: 4000,
            panelClass: ['green-snackbar'],

        });

    }

    closeAccountMenu() {
        if (this.menuTrigger) {
            this.menuTrigger.closeMenu();
        }
        // this.cd.detectChanges();
    }

    /**
     * Used in Study Methods Menu
     */
    async get_study_methods() {

        await this.api.fetch_study_methods()
            .subscribe(res => {
                this.studyMethods = res.data.items;
                this.cd.detectChanges();
            }, (err) => {
                this.cd.detectChanges();
            });
    }

    /**
     * Used for showing and interacting with the mega menu
     * @param classText
     */
    appendClass(classText: string) {

        this.showMenuDropDown = classText;

        document.body.classList.add(classText);

    }

    /**
     * Used for hiding and interacting with the mega menu
     * @param classText 
     */
    removeClass(classText: string) {

        if (classText != 'courses-show') {
            this.showMenuDropDown = '';
        }
        document.body.classList.remove(classText);

    }

    removeOtherSubheadClasses(classText: string) {

        this.headers.forEach(header => {
            if (header.subitems.length > 0 && header.url != classText) {
                document.body.classList.remove(header.url + '-show');

            }

        });

    }

    /**
     * Fetches all insitutions.
     * This is then split up into partner institutions and national qualifications
     */
    async fetchInstitutions() {

        await this.api.fetch_institutions()
            .subscribe(res => {
                this.megaMenu = res.data.items;

                this.megaMenu.forEach(element => {
                    const index = this.catalystCourses?.findIndex(x => x.CourseKey._text == element.identifier);
                    if (index !== -1 && this.catalystCourses !== undefined) {
                        if (Array.isArray(this.catalystCourses[index].SubjectLevels.SubjectLevel)) {
                            element.SubjectLevel = this.catalystCourses[index].SubjectLevels.SubjectLevel;
                        } else {
                            element.SubjectLevel = [this.catalystCourses[index].SubjectLevels.SubjectLevel];
                        }
                    }
                });

                // Get and replace custom level titles from the CMS
                this.megaMenu.forEach(course => {
                    if (course !== undefined && course !== null) {
                        course.SubjectLevel?.forEach(level => {
                            if (level !== undefined && level !== null) {
                                const index = course.levels.findIndex(x => x.identifier == level.SubjectLevelKey._text);

                                if (index !== -1) {
                                    level.SubjectLevelName._text = course.levels[index].title;
                                    level.Priority = course.levels[index].priority;
                                } else {
                                    level.Priority = '';
                                }
                            }
                        });

                        course.SubjectLevel?.sort((a, b) => {
                            if (a.Priority < b.Priority) {
                                return -1;
                            }
                            if (a.Priority > b.Priority) {
                                return 1;
                            }
                            return 0;
                        });
                    }
                });


                this.fetchLocalSubjects();
                this.cd.detectChanges();
            }, (err) => {
                if (typeof err !== 'undefined') {
                    console.error('Error fetching courses:', err);
                }
            });

    }

    /**
     * Used for showing and interacting with the mega menu
     * @param classText
     */
    async fetchCourses() {

        await this.api.fetch_course_list()
            .subscribe(res => {
                this.catalystCourses = res.Result?.Course;
                this.fetchInstitutions();
            }, (err) => {

            });

    }

    /**
     * Hover on course to change selected courses and then select first available level
     * @param item
     */
    selectCourse(item) {
        this.resetUpcoming();
        this.selectedMegaMenuCourse = item;
        this.selectedMegaMenuLevel = item.SubjectLevel?.[0];
    }

    /**
     * Hover on level to select and change the subjects shown
     * @param item
     */
    selectLevel(item) {
        this.resetUpcoming();
        this.selectedMegaMenuLevel = item;
    }

    /**
     * Hover on subject to select and change the upcoming courses
     * @param item
     */
    selectSubject(item) {
        // this.resetUpcoming();
        this.selectedMegaMenuSubject = item;
        this.fetchOfferedSubjects();
    }

    /**
     * Don't show an upcoming course
     */
    resetUpcoming() {
        this.upcomingCourseState = '';
    }

    /**
     * Used to show custom subject titles in the mega menu
     */
    async fetchLocalSubjects() {

        await this.api.fetch_subjects()
            .subscribe(res => {
                this.localSubjects = res.data.items;

                this.megaMenu.forEach(element => {
                    element.SubjectLevel?.forEach(level => {
                        if (level !== undefined && level !== null) {
                            if (!Array.isArray(level.Subjects.Subject)) {
                                level.Subjects.Subject = [level.Subjects.Subject];
                            }

                            level.Subjects.Subject.forEach(subject => {
                                if (subject !== undefined && subject !== null) {
                                    const index = this.localSubjects.findIndex(x => x.identifier == subject.SubjectKey._text);

                                    if (index !== -1) {
                                        subject.title = this.localSubjects[index].title;
                                        subject.slug = this.localSubjects[index].slug;
                                        subject.how_it_works_sections = this.localSubjects[index].how_it_works_sections;
                                    } else {
                                        subject.title = '';
                                        subject.slug = '';
                                    }
                                }
                            });
                        }

                    });
                });

                this.megaMenuLoaded = true;
                this.selectedMegaMenuCourse = this.megaMenu[0];
                this.selectedMegaMenuLevel = this.megaMenu[0]?.SubjectLevel?.[0];
                this.cd.detectChanges();
            }, (err) => {

            });

    }

    /**
     * Fetch the product based on the method id and subject id. Used ofor upcoming course
     */
    async fetchOfferedSubjects() {

        this.upcomingCourseState = 'loading';

        await this.api.fetch_offered_subject_products(this.selectedMegaMenuCourse.identifier)
            .subscribe(res => {
                if (res.Result.hasOwnProperty('SubjectLevels')) {
                    const subjectLevelArr = this.ensureArray(res?.Result?.SubjectLevels?.SubjectLevel);
                    subjectLevelArr?.forEach(level => {

                        const subjects = this.ensureArray(level.Subjects.Subject);

                        const index = subjects?.findIndex(
                            x => x.SubjectKey._text == this.selectedMegaMenuSubject.SubjectKey._text
                        );

                        if (index !== -1 && index !== undefined) {
                            this.upcomingCourse = subjects[index]?.StudyMethods?.StudyMethod[0];
                            this.upcomingSubject = subjects[index]?.StudyMethods?.StudyMethod[0]?.Products?.Product;

                            this.upcomingCourseState = 'show';
                            // Get the region list
                            if (this.upcomingSubject && typeof this.upcomingSubject !== 'undefined') {
                                this.getRegionList(this.upcomingSubject.ProductKey._text);
                            }
                        }

                    });
                }

                this.cd.detectChanges();
            }, (err) => {
                console.error('Error fetching subjects:', err);
            });

    }


    /**
     * Fetches all regions for a certain product
     */
    async getRegionList(productKey) {

        await this.api.get_region_list(productKey)
            .subscribe(res => {
                this.regions = this.ensureArray(res?.Result?.Regions?.Region);
                this.cd.detectChanges();
            }, (err) => {

            });

    }

    // Toggle search
    searchToggle(event: string) {
        this.showSearch = !this.showSearch;
    }

    goBack() {
        this._location.back();
    }

    cartGoBack() {
        this._location.back();
    }

    loadStudyMethod(studyMethod) {
        this.zone.run(() => {
            this.router.navigate(['/study-methods/' + studyMethod?.slug]);
        });
    }

    async getNotification() {

        await this.api.fetch_notification()
            .subscribe(res => {
                this.notification = (res.data) ? res?.data?.item?.notification : '';
            }, (err) => {
                // nothing
            });


    }

    /**
     * Slugify a string. Used with the study method name
     * @param str
     * @returns
     */
    slugify(str) {
        str = (str === null) ? '' : str;
        str = this.replaceAccents(str);
        str = this.removeNonWord(str);
        str = str.replace(/ +/g, '-')   // replace spaces with delimiter
            .toLowerCase();

        return str;
    }

    /**
     * Ensure that the response from Catalyst is an array.
     * Note: This is because the response format for a single item is different compared to multiple items
     * @param possibleArray
     * @returns
     */
    ensureArray(possibleArray) {
        if (possibleArray) {
            if (Array.isArray(possibleArray)) {
                return possibleArray;
            } else {
                return [possibleArray];
            }
        } else {
            return [];
        }
    }

    parseIt(item) {

        return JSON.parse(item).replace(/(<([^>]+)>)/ig, '');
    }


    /**
     * Remove non-word chars.
     */
    removeNonWord(str) {
        return str.replace(/[^0-9a-zA-Z\xC0-\xFF \-]/g, '');
    }

    /**
     * Replaces all accented chars with regular ones
     */
    replaceAccents(str) {
        if (str.search(/[\xC0-\xFF]/g) > -1) {
            str = str
                .replace(/[\xC0-\xC5]/g, 'A')
                .replace(/[\xC6]/g, 'AE')
                .replace(/[\xC7]/g, 'C')
                .replace(/[\xC8-\xCB]/g, 'E')
                .replace(/[\xCC-\xCF]/g, 'I')
                .replace(/[\xD0]/g, 'D')
                .replace(/[\xD1]/g, 'N')
                .replace(/[\xD2-\xD6\xD8]/g, 'O')
                .replace(/[\xD9-\xDC]/g, 'U')
                .replace(/[\xDD]/g, 'Y')
                .replace(/[\xDE]/g, 'P')
                .replace(/[\xE0-\xE5]/g, 'a')
                .replace(/[\xE6]/g, 'ae')
                .replace(/[\xE7]/g, 'c')
                .replace(/[\xE8-\xEB]/g, 'e')
                .replace(/[\xEC-\xEF]/g, 'i')
                .replace(/[\xF1]/g, 'n')
                .replace(/[\xF2-\xF6\xF8]/g, 'o')
                .replace(/[\xF9-\xFC]/g, 'u')
                .replace(/[\xFE]/g, 'p')
                .replace(/[\xFD\xFF]/g, 'y');
        }

        return str;
    }
}
